import $ from 'jquery'
import { breakpoints } from './_site'
require('slick')

export const create = ($slider, options) => {
  $slider.each(function () {
    var $self = $(this),
      $container = $self.closest('.slider'),
      $nav = $container.find('.slider__nav'),
      $dots = $container.find('.slider__dots'),
      $cycle = $self.find('.slider__cycle'),
      defaultOptions = {
        infinite: true,
        arrows: true,
        dots: true,
        fade: true,
        appendDots: $dots,
        appendArrows: $nav,
        autoplay: false,
        speed: 400,
        prevArrow: '<span class="slider__button slider__button--prev" title="Previous"></span>',
        nextArrow: '<span class="slider__button slider__button--next" title="Next"></span>',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: breakpoints.sm,
            settings: {
              // arrows: false,
              fade: false,
            },
          },
          {
            breakpoint: breakpoints.xs,
            settings: {
              // arrows: false,
              fade: false,
            },
          },
        ],
      }

    // extend options
    $.extend(defaultOptions, options)

    destroy($self)

    $cycle.slick(defaultOptions)
  })
}
export const destroy = ($slider, options) => {
  var $cycle = $slider.find('.slider__cycle')

  if ($cycle.hasClass('slick-initialized')) {
    $cycle.slick('unslick')
  }
}
export const binds = () => {
  // ---------------- slider reload since sizes are incorrect on hidden content
  $('[data-toggle=tab]').on('shown.bs.tab', function (event) {
    var $target = $(event.target),
      $tab = $($target.data('target')),
      $slider = $tab.find('.slider__cycle')

    if ($slider.length) {
      $slider[0].slick.refresh()
    }
  })
}
